import { Api, DataResponse } from "imagine-essentials";
import {
  Address,
  AvailableUser,
  DeleteStatus,
  Project,
  ProjectsFilter,
} from "..";
import { User } from "imagine-users";

const addProject = async (project: Project) => {
  const result = await Api.post("api/projects/add", project);
  const response: DataResponse<Project> = {
    success: result.success,
  };
  if (result.success && result.data) {
    response.data = result.data;
  }
  return response;
};

const updateProject = async (project: Project) => {
  const result = await Api.post("api/projects/update/" + project.id, project);
  const response: DataResponse<Project> = {
    success: result.success,
  };
  if (result.success && result.data) {
    response.data = result.data;
  }
  return response;
};

const addProjectAccess = async (projectId: number, userId: number) => {
  const result = await Api.post("api/projects/access/add", {
    projectId,
    userId,
  });
  const response: DataResponse<void> = {
    success: result.success,
  };
  return response;
};

const removeProjectAccess = async (projectId: number, userId: number) => {
  const result = await Api.post("api/projects/access/remove", {
    projectId,
    userId,
  });
  const response: DataResponse<void> = {
    success: result.success,
  };
  return response;
};

const getProject = async (id: number) => {
  const result = await Api.get("api/projects/" + id);
  const response: DataResponse<Project> = {
    success: result.success,
  };
  if (result.success && result.data) {
    response.data = result.data;
  }
  return response;
};

const getProjects = async (filter: ProjectsFilter) => {
  const result = await Api.get("api/projects", filter);
  const response: DataResponse<Project[]> = {
    success: result.success,
  };
  if (result.success && result.data) {
    response.data = result.data;
  }
  return response;
};

const getClosedProjects = async (filter: ProjectsFilter) => {
  const result = await Api.get("api/closed-projects", filter);
  const response: DataResponse<Project[]> = {
    success: result.success,
  };
  if (result.success && result.data) {
    response.data = result.data;
  }
  return response;
};

const getAvailableUsers = async () => {
  const result = await Api.get("api/projects/available-users");
  const response: DataResponse<AvailableUser[]> = {
    success: result.success,
  };
  if (result.success && result.data) {
    response.data = result.data;
  }
  return response;
};

const getAddress = async (id: number) => {
  const result = await Api.get("api/addresses/" + id);
  const response: DataResponse<Address> = {
    success: result.success,
  };
  if (result.success && result.data) {
    response.data = result.data;
  }
  return response;
};

const updateAddress = async (address: Address) => {
  const baseAddress = {
    ...address,
  };
  if (baseAddress.defects) {
    delete baseAddress.defects; // Remove defects from the address object to avoid sending them in the update request
  }
  const result = await Api.post("api/addresses/update/" + address.id, address);
  const response: DataResponse<Address> = {
    success: result.success,
  };
  if (result.success && result.data) {
    response.data = result.data;
  }
  return response;
};

const updateAddresses = async (addresses: Address[]) => {
  const result = await Api.post("api/addresses/update", {
    addresses: addresses,
  });
  const response: DataResponse<void> = {
    success: result.success,
  };
  if (result.success && result.data) {
    response.data = result.data;
  }
  return response;
};

const approveAddress = async (id: number) => {
  const result = await Api.post("api/addresses/approve/" + id, {});
  const response: DataResponse<void> = {
    success: result.success,
  };
  return response;
};

const generateProjectPdf = async (projectId: number) => {
  const result = await Api.post("api/projects/pdf/" + projectId, {});
  const response: DataResponse<void> = {
    success: result.success,
  };
  if (result.success && result.data) {
    response.data = result.data;
  }
  return response;
};

const generateProjectWelcomeLetter = async (projectId: number) => {
  const result = await Api.post("api/projects/letter/" + projectId, {});
  const response: DataResponse<void> = {
    success: result.success,
  };
  if (result.success && result.data) {
    response.data = result.data;
  }
  return response;
};

const generateAddressPdf = async (addressId: number) => {
  const result = await Api.post("api/addresses/pdf/" + addressId, {});
  const response: DataResponse<void> = {
    success: result.success,
  };
  if (result.success && result.data) {
    response.data = result.data;
  }
  return response;
};

const generateAddressWelcomeLetter = async (addressId: number) => {
  const result = await Api.post("api/addresses/letter/" + addressId, {});
  const response: DataResponse<void> = {
    success: result.success,
  };
  if (result.success && result.data) {
    response.data = result.data;
  }
  return response;
};

const deleteProject = async (projectId: number) => {
  const result = await Api.post("api/projects/delete/" + projectId, {});
  console.log("Delete project:", result);
  const response: DataResponse<{
    deleted: DeleteStatus;
    failed: DeleteStatus;
  }> = {
    success: result.success,
  };
  if (result.success && result.data) {
    response.data = result.data;
  }
  return response;
};

export const ProjectsApi = {
  addProject,
  updateProject,
  addProjectAccess,
  removeProjectAccess,
  getProject,
  getProjects,
  getClosedProjects,
  getAvailableUsers,
  getAddress,
  updateAddress,
  updateAddresses,
  approveAddress,
  generateProjectPdf,
  generateProjectWelcomeLetter,
  generateAddressPdf,
  generateAddressWelcomeLetter,
  deleteProject,
};
